import './NotificationLink.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Link } from '../../../../design/links/S_Link';
import { useExportDataBl } from '../../../../modules/projects/details/exportData/ExportData.bl';
import { ExportDataFilter } from '../../projects/projects.model';

interface IProps {
  projectExportId: string;
  exportDataFilter: ExportDataFilter;
}

export const DownloadExportContainer = observer((props: IProps): ReactElement => {
  const bl = useExportDataBl();
  const { projectExportId, exportDataFilter } = props;
  const { t } = useTranslator();

  const handleClick = (): void => {
    bl.showDownloadModal(projectExportId, exportDataFilter);
  };

  return (
    <S_Link
      onClick={handleClick}
      className='notification-link'
      color='anchor'
    >
      {t('activity_description_Export_02')}
    </S_Link>
  );
});
